import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { COUNTRIES, DEFAULT_CURRENCY } from 'my-core/constants';
import { studySessionBundlePurchased } from 'my-core/gtm-events';
import { useCurrentUser, useStandardApiRequest } from 'my-core/hooks';

import StudySessionBundleCheckout from './StudySessionBundleCheckout';

import { confirmStudySessionBundlePurchase } from 'my-actions/StudySessionBundleActions';

export default function StudySessionBundleCheckoutCtnr({ course, onClose, open, studySessionBundle }) {
  const currentUser = useCurrentUser();

  const [activeStep, setActiveStep] = useState(0);

  const pricingInfo = useMemo(
    () => ({
      countryCode: course?.country_code || currentUser.country_code,
      currency: course?.currency || COUNTRIES[currentUser.country_code]?.currency || DEFAULT_CURRENCY,
      salesTax: Number(course?.currency ? course.sales_tax : COUNTRIES[currentUser.country_code]?.sales_tax) || 0,
    }),
    [currentUser.country_code, course],
  );

  const purchaseDetailsRef = useRef();
  const { performRequest: performConfirmPurchase, requestStatus: confirmPurchaseStatus } = useStandardApiRequest({
    actionCreator: confirmStudySessionBundlePurchase,
    errorMessage: true,
    onSuccess: requestStatus => {
      setActiveStep(1);
      studySessionBundlePurchased(
        { ...studySessionBundle, course },
        { id: requestStatus.id },
        purchaseDetailsRef.current,
      );
    },
  });

  const handlePayment = useCallback(
    ({ currency, discountCode, paymentIntent, total }) => {
      purchaseDetailsRef.current = { total, discountCode, currency };
      performConfirmPurchase(studySessionBundle.id, paymentIntent?.id, discountCode?.id);
    },
    [performConfirmPurchase, studySessionBundle.id],
  );
  const studySessionBundleUser = useSelector(state => state.studySessionBundleUsers.items[confirmPurchaseStatus?.id]);

  return (
    <StudySessionBundleCheckout
      activeStep={activeStep}
      confirming={!!confirmPurchaseStatus?.fetching}
      course={course}
      currentUser={currentUser}
      onChangeStep={setActiveStep}
      onClose={onClose}
      onPaymentSuccess={handlePayment}
      open={open}
      pricingInfo={pricingInfo}
      studySessionBundle={studySessionBundle}
      studySessionBundleUser={studySessionBundleUser}
    />
  );
}
